export default __webpack_public_path__ + "static/media/header-bg.32c79266.png";